<template>
  <v-toolbar-items>
    <v-menu left offset-y>
      <v-btn flat slot="activator">
        {{ currentLanguage.short }}
      </v-btn>

      <v-list>
        <v-list-tile
          v-for="(lang, i) in languages"
          :key="i"
          @click="changeLocale(lang.locale)"
        >
          <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
export default {
  name: 'DropdownLanguage',
  computed: {
    currentLanguage () {
      return this.languages.find(l => l.locale === this.$i18n.locale)
    }
  },
  data () {
    return {
      languages: [
        {
          flag: 'br',
          locale: 'pt_BR',
          name: 'Português',
          short: 'PT',
          flagName: 'Brasil'
        },
        {
          flag: 'us',
          locale: 'en',
          name: 'English',
          short: 'EN',
          flagName: 'United States'
        }
      ]
    }
  },
  methods: {
    changeLocale (locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>
